<template>
   <div class="hello">
      <nav class="navbar navbar-light bg-light">
         <a v-bind:href=linkUni[currentLocale]>
         <img :src=logo[currentLocale] width="300px">
         </a>
         <div>
            <select v-model="currentLocale" class="form-control inputstl" >
               <option v-for="locale in locales" v-bind:value="locale.id">{{locale.name}}</option>
            </select>
         </div>
      </nav>
      <div class="container">
         <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
               <h1>{{ title[currentLocale] }}</h1>
            </div>
            <div class="col-md-2"></div>
         </div>
         <div class="row nav"></div>
         <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-5">
               <a v-bind:href=linktool2[currentLocale] target="_blank">
               <img src="../assets/2-How-much-time-will-it-take-1024x1024.png" 
                  alt="How Much Work Is It?" class="img-responsive"  width=150px>                            
               </a>
               <h3>
                  {{ tool2[currentLocale] }}
               </h3>
            </div>
            <div class="col-md-5">
               <a v-bind:href=linktool3[currentLocale] target="_blank">
               <img src="../assets/3-Who-will-support-me-1024x1024.png" alt="Who Can I Ask?"
                  class="img-responsive" width=150px>
               </a>
               <h3>
                  {{ tool3[currentLocale] }}
               </h3>
            </div>
            <div class="col-md-1"></div>
         </div>
      </div>
   </div>
</template>
<script>
   import BootstrapVue from "bootstrap-vue";
   import "bootstrap/dist/css/bootstrap.css";
   import "bootstrap-vue/dist/bootstrap-vue.css";
   
   export default {
     name: "sst",
     data() {
       return {
         title: {
           fr:
             "En route vers le succès grâce aux outils pour gérer son temps et son réseau !",
           de: "Mit Zeitmanagement und Netzwerkpflege zum Studienerfolg!"
         },
         tool2: {
           fr: "Ai-je assez de temps ?",
           de: "Habe ich genug Zeit?"
         },
         tool3: {
           fr: "Auprès de qui trouver du soutien ?",
           de: "Wen kann ich fragen?"
         },
         linktool2: {
           fr: "https://studentsuccess.fernuni.ch/fr/tool2",
           de: "https://studentsuccess.fernuni.ch/de/tool2"
         },
         linktool3: {
           fr: "https://studentsuccess.fernuni.ch/fr/tool3",
           de: "https://studentsuccess.fernuni.ch/de/tool3"
         },
         logo: {
           fr:
             "https://fernuni.ch/fileadmin/fernuni.ch/Resources/Public/Images/logo_fr.svg",
           de:
             "https://fernuni.ch/fileadmin/fernuni.ch/Resources/Public/Images/logo_de.svg"
         },
         linkUni: {
           fr: "https://www.unidistance.ch",
           de: "https://www.fernuni.ch"
         },
       
         currentLocale: (navigator.language.substring(0,2) != "") || (navigator.language.substring(0,2) != null) ? (navigator.language.substring(0,2)) : "de",    
         locales: [{ id: "fr", name: "Français" }, { id: "de", name: "Deutsch" }]
       };
     },    
   };
</script>
<style scoped>
   h1,
   h2 {
   font-family: 'Droid Serif',serif;
   font-weight: 700;  
   color: #2d457c !important;  
   padding: 25px 10px;
   },
   h3 {
   font-family: 'Droid Serif',serif;
   font-weight: normal;  
   color: #2d457c !important;
   padding: 10px;
   },
   ul {
   list-style-type: none;
   padding: 0;
   }
   li {
   display: inline-block;
   margin: 0 5px;
   }
   ul li a {
   font-family: 'Droid Serif',serif;
   font-weight: 400;
   color: #2d457c !important;
   display: block;
   padding: 8px 10px;
   text-decoration: none;
   }
</style>


// WEBPACK FOOTER //
// src/components/sst.vue